import { isDevelopment } from 'helpers/utils/environment';

const SiteMap: any = {
  /*
  localhost: {
    uk: 'localhost:3000',
    eu: '127.0.0.1:3000',
  },
  '127': {
    uk: 'localhost:3000',
    eu: '127.0.0.1:3000',
  },
  */
  dev: { uk: 'dev.americangolf.co.uk', eu: 'dev2.americangolf.eu' },
  dev2: { uk: 'dev.americangolf.co.uk', eu: 'dev2.americangolf.eu' },
  'dev-gb': { uk: 'dev-gb.americangolf.co.uk', eu: 'dev-eu.americangolf.co.uk' },
  'dev-eu': { uk: 'dev-gb.americangolf.co.uk', eu: 'dev-eu.americangolf.co.uk' },
  www: { uk: 'www.americangolf.co.uk', eu: 'www.americangolf.eu' },
  staging: { uk: 'staging.americangolf.co.uk', eu: 'staging.americangolf.eu' },
  qa: { uk: 'qa.americangolf.co.uk', eu: 'qa.americangolf.eu' },
};
const RedirectToProperDomain = (
  selectedCountry: string,
  cookies: { locale_selection?: any; 'frontastic-session'?: any },
) => {
  const redirectToProperDomain = (selectedCurrency: string) => {
    const currentUrl = new URL(window.location.href);
    const currentDomain = currentUrl.hostname;
    const currentCurrency = cookies?.['locale_selection']?.currency || '';

    const targetDomain = getTargetDomain(currentDomain, selectedCurrency);
    if (!targetDomain) {
      console.warn(`No mapping found for current domain: ${currentDomain}`);
      return null;
    }

    const targetDomainTmp = targetDomain.split(':')[0];
    if (currentCurrency === selectedCurrency && currentDomain == targetDomainTmp) {
      return null;
    }

    const path = currentUrl.pathname;
    const protocol = isDevelopment() ? 'http' : 'https';
    const url = `${protocol}://${targetDomain}${path}?fs=${cookies?.['frontastic-session']}&c=${selectedCurrency}&cc=${selectedCountry}`;
    return url;
  };

  const getTargetDomain = (currentDomain: string, selectedCurrency: string) => {
    // if (currentDomain === 'localhost') {
    //   return 'testapplepay.ngrok.io';
    // } else if (currentDomain === 'testapplepay.ngrok.io') {
    //   return 'localhost:3000';
    // } else {

    const subdomain = currentDomain.split('.')[0];
    const targetCountry = selectedCurrency === 'GBP' ? 'uk' : 'eu';
    return SiteMap[subdomain]?.[targetCountry];
    // }
  };

  return redirectToProperDomain;
};

export default RedirectToProperDomain;
